import initializeBannerCarousel from "./heroBannerCarousel";
import initializeProductsCarousel from "./productsCarousel";
import initializeOfferTileListeners from "./offerTile";
import initializeLeadForms from "./leadForm";
import initializeVideoLp from "./assets/videoLP";
import initializeBannerProductSecondary from "./assets/bannerProductSecondary";
import initializeBannerSecondary from "./assets/bannerSecondary";
import initializeCollapseComponent from "./layouts/collapseComponent";
import initializeTabsSection from "./layouts/tabsSection";
import initializeTabsWithSearchSection from "./layouts/tabsWithSearchSection";
import initListHelper from "./listHelper";
import initializeArcgisMap from "./assets/arcgisMap";
import initializeOfferAndMedia from "./layouts/offerAndMedia";

const initializeExperienceComponents = () => {
    initializeBannerCarousel();
    initializeProductsCarousel();
    initializeOfferTileListeners();
    initializeLeadForms();
    initializeVideoLp();
    initializeTabsSection();
    initializeBannerProductSecondary();
    initializeTabsWithSearchSection();
    initializeCollapseComponent();
    initializeBannerSecondary();
    initListHelper();
    initializeArcgisMap();
    initializeOfferAndMedia();
};

export default initializeExperienceComponents;
